<strong></strong><template>
	<Modal v-model="show" :title="'招投标记录编辑'" :mask-closable="false" :closable='false' width="800">
		<Form :model="form" ref="form" :rules="rules" :label-width="120" inline>
			<FormItem label="客户简名:" prop="customerId">
				<Select v-model="form.customerId" style="width:200px" disabled @on-change="getSalesman">
					<Option v-for="item in customerJMData" :value="item.value" :key="item.value">{{ item.name }}
					</Option>
				</Select>
			</FormItem>
			<FormItem label="投标时间:" prop="biddingTime">
				<DatePicker type="datetime" @on-change="form.biddingTime = $event" disabled :value="form.biddingTime"
					placeholder="请选择" style="width: 200px" />
			</FormItem>

			<FormItem label="客户物料代码:" prop="materialCode">
				<Input v-model="form.materialCode" placeholder="请输入" disabled style="width: 200px"></Input>
			</FormItem>
			<FormItem label="产品名称:" prop="productName">
				<Input v-model="form.productName" placeholder="请输入" disabled style="width: 200px"></Input>
			</FormItem>
			<FormItem label="投标金额：" prop="bidAmountRaw">
				<Input placeholder="请输入" :value="form.bidAmountRaw" disabled style="width: 200px;"
					@input="formatBidAmount" ><template #append>
					<span>元</span>
				</template></Input>
			</FormItem>
			<FormItem label="业务员:" prop="salesman">
				<Select v-model="form.salesman" style="width:200px" disabled>
					<Option v-for="item in salesmanData" :value="item.value" :key="item.value">{{ item.name }}</Option>
				</Select>
			</FormItem>
			<FormItem label="成本：" prop="costRaw">
				<Input placeholder="请输入" :value="form.costRaw" disabled style="width: 200px;"
					@input="formatCost" @on-change="calculateGrossMargin()"><template #append>
					<span>元</span>
				</template></Input>
			</FormItem>
			<FormItem label="是否中标:" prop="isSuccessfulBid" v-if="form.id!==null">
				<RadioGroup v-model="form.isSuccessfulBid" style="width: 200px" @on-change="changeSuccessfulBid()">
					<Radio :label="true"><span>是</span></Radio>
					<Radio :label="false"><span>否</span></Radio>
				</RadioGroup>
			</FormItem>
			<FormItem label="中标单位:" prop="winningBidder"
				:rules="{ required: form.isSuccessfulBid === false, message: '请输入', trigger: 'change' }" v-if="form.id!==null">
				<Input v-model="form.winningBidder" placeholder="请输入" style="width: 200px"
					:disabled="isDisabled"></Input>
			</FormItem>
			<FormItem label="中标价格：" prop="bidWinningPriceRaw" v-if="form.id!==null">
				<Input placeholder="请输入" :value="form.bidWinningPriceRaw" style="width: 200px;"
					@input="formatbidWinningPrice" @on-change="calculateGrossMargin()"><template #append>
					<span>元</span>
				</template></Input>
			</FormItem>
			
			<FormItem label="毛利率:" prop="grossMargin" v-if="form.id!==null">
				<Input v-model="form.grossMargin" placeholder="请输入" style="width: 200px" disabled></Input><label
					style="margin-left: 5px;">%</label>
			</FormItem>
		</Form>
		<Spin size="large" fix v-show="spinShow"></Spin>
		<div slot="footer">
			<Button @click="close()" class="close-btn">关闭</Button>
			<Button @click="submit()" type="primary" :disabled="spinShow" class="close-btn">提交</Button>
		</div>
	</Modal>
</template>
<script>
	export default {
		name: 'CreateBid',
		props: {
			show: Boolean, //弹窗 窗口显示
			customerId: Number,
			quotationId: Number,
			departmentType: Number
		},
		data() {
			return {
				accept: 'image/*',
				format: ['jpg', 'pdf', 'png', 'jpeg'],
				form: {
					materialCode: '',
					productName: '',
					bidAmount: null,
					bidAmountRaw: null,
					salesman: null,
					isSuccessfulBid: null,
					biddingTime: null,
					winningBidder: '',
					bidWinningPrice: null,
					bidWinningPriceRaw: null,
					cost: null,
					costRaw: null,
					grossMargin: null,
					customerId: this.customerId,
					id: this.quotationId,
					departmentType: this.departmentType
				},
				mustInput: true,
				rules: {
					customerId: [{
						required: true,
						message: '请选择',
						trigger: 'blur,change',
						type: 'number'
					}],
					salesman: [{
						required: true,
						message: '请选择',
						trigger: 'blur,change',
						type: 'number'
					}],
					materialCode: [{
						required: true,
						message: '请输入',
						trigger: 'blur,change',
						type: 'string'
					}, ],
					productName: [{
						required: true,
						message: '请输入',
						trigger: 'blur,change',
						type: 'string'
					}, ],
					isSuccessfulBid: [{
						required: false,
						message: '请选择',
						trigger: 'blur,change',
						type: 'boolean'
					}, ],
					// bidAmount:[{ required: true, message: '投标金额不能为空',},{ message: '投标金额只能是数字', trigger:'change', pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/,}],
					bidAmountRaw: [{
							required: true,
							message: '投标金额不能为空',
							trigger: 'blur'
						},
						// {
						// 	message: '投标金额格式错误，只能是数字且小数点后最多两位',
						// 	trigger: 'change',
						// 	pattern: /^\d+(\.\d{0,2})?$/,
						// },
					],
					vehicleEntryNotice: [{
						required: false,
						message: '请输入',
						trigger: 'blur,change',
						type: 'string'
					}, ],
					// cost:[{ required: true, message: '成本不能为空',},{ message: '成本只能是数字', trigger:'change', pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/,}],
					// bidWinningPrice:[{ required: true, message: '中标价格不能为空',},{ message: '中标价格只能是数字', trigger:'change', pattern:/^(([1-9]\d{0,3})|0)(\.\d{0,2})?$/,}],
					// biddingTime: [
					// 	{
					// 		required: true,
					// 		pattern: /.+/,
					// 		validator: this.validateDate,
					// 		trigger: 'blur',
					// 	},
					// ],
					winningBidder: [{
						required: this.mustInput,
						message: '请输入',
						trigger: 'blur,change',
						type: 'string'
					}, ],
					costRaw: [{
							required: true,
							message: '成本不能为空',
							trigger: 'blur'
						},
						// {
						// 	message: '成本格式错误，只能是数字且小数点后最多两位',
						// 	trigger: 'change',
						// 	pattern: /^\d+(\.\d{0,2})?$/,
						// },
					],
					bidWinningPriceRaw: [{
						required: true,
						message: '中标价格不能为空',
						trigger: 'blur'
					}, ],
					biddingTime: [{
						required: true,
						message: '请选择',
						trigger: 'blur'
					}, ],
				},
				salesmanData: [], //
				customerJMData: [], //
				companyName: '',
				spinShow: false,
				hasCustomer: false,
				isDisabled: false,
			}
		},
		mounted() {
			this.getUser()

		},
		methods: {
			formatbidWinningPrice(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');

					// 将纯数值赋值给 this.form.bidWinningPrice
					this.form.bidWinningPrice = pureValue;

					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.form.bidWinningPriceRaw
					this.$set(this.form, 'bidWinningPriceRaw', formattedValue)
				}
			},
			addThousandSeparator(value) {
				// 将数值部分和小数部分分开
				let parts = value.split('.');
				// 格式化整数部分，添加千位符
				parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
				// 重新组合整数部分和小数部分
				return parts.join('.');
			},
			formatCost(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.form.cost
					this.form.cost = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.form.costRaw
					this.$set(this.form, 'costRaw', formattedValue)
				}
			},
			formatBidAmount(event) {
				console.log(event);
				let value = event
				if (value) {
					// 移除所有非数字和小数点的字符
					let pureValue = value.replace(/[^\d.]/g, '');
			
					// 将纯数值赋值给 this.form.bidAmount
					this.form.bidAmount = pureValue;
			
					// 格式化数值，添加千位符
					let formattedValue = this.addThousandSeparator(pureValue);
					
					// 将格式化后的数值赋值给 this.form.bidAmountRaw
					this.$set(this.form, 'bidAmountRaw', formattedValue)
				}
			},
			// 关闭弹窗
			close(refresh) {
				this.form = {
					afterSalesAttire: null,
					tool: null,
					personnelSafety: null,
					contactsIdList: [],
					vehicleEntryNotice: '',
					customerId: this.customerId,
					id: 0
				}
				this.$refs['form'].resetFields()
				this.$emit('close', refresh)
			},
			//   提交记录
			submit() {
				let _this = this
				this.$refs['form'].validate(async (valid) => {
					if (valid) {
						let files = []
						// if (this.form.模板_Files.length > 0) {
						//   this.form.模板_Files.map((file) => {
						//     files.push(file.fileGuids)
						//   })
						//   this.form.templateGuids = files.join(',')
						// }
						this.spinShow = true
						var url = ''
						this.form.bidWinningPrice = this.form.bidWinningPriceRaw;
						this.form.cost = this.form.costRaw;
						this.form.bidAmount = this.form.bidAmountRaw;
						if (this.form.id != null && this.form.id != 0) {
							url = '/api/services/app/CustomerBidApiService/UpdateCustomerBid'
							let {
								data
							} = await this.$Ajax.put(
								url,
								this.form
							)
							if (data.success) {
								this.$Message.success({
									content: '编辑成功',
								})
								_this.close(true)
							}
						} else {
							url = '/api/services/app/CustomerBidApiService/Create'
							let {
								data
							} = await this.$Ajax.post(
								url,
								this.form
							)
							if (data.success) {
								this.$Message.success({
									content: '新建成功',
								})
								_this.close(true)
							}
						}
						this.spinShow = false
					}
				})
			},
			//   获取下拉框数据
			async getUser() {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerBidApiService/GetBidMgrInitData?departmentType=${this.departmentType}`
				)
				this.customerJMData = data.result.customerJMData
				this.salesmanData = data.result.salesmanData
				this.form.salesman = data.result.salesman
				this.hasCustomer = data.result.hasCustomer

				if (this.customerId) {
					this.getInfo()
				}
				if (this.quotationId) {
					this.getDetail()
				}
			},
			async getInfo() {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerBidApiService/GetInfoInitData?customerId=${this.customerId}`
				)
				this.form.salesman = data.result.salesman
				this.companyName = data.result.companyName
				this.spinShow = false
			},
			async getDetail() {
				const {
					data
				} = await this.$Ajax.get(
					`/api/services/app/CustomerBidApiService/GetDetailById?id=${this.quotationId}`
				)
				this.form = data.result
				if (this.form.isSuccessfulBid) {
					this.isDisabled = true
				} else {
					this.isDisabled = false
				}
				this.spinShow = false
			},
			async getSalesman() {
				if (this.form.customerId && this.form.customerId > 0) {
					const {
						data
					} = await this.$Ajax.get(
						`/api/services/app/CustomerBidApiService/GetInfoInitData?customerId=${this.form.customerId}`
					)
					this.form.salesman = data.result.salesman
				}
			},
			changeSuccessfulBid() {
				if (this.form.isSuccessfulBid) {
					this.isDisabled = true
					this.form.winningBidder = this.companyName
				} else {
					this.isDisabled = false
					this.form.winningBidder = ''
				}
			},
			calculateGrossMargin() {
				if (this.form.bidWinningPrice != null && this.form.bidWinningPrice != '' && this.form.cost != null && this
					.form.cost != '') {
					let profit = this.form.bidWinningPrice - this.form.cost;
					this.form.grossMargin = (profit / this.form.bidWinningPrice) * 100
				} else {
					this.form.grossMargin = null;
				}
			},
			//判断请假日期
			validateDate(rule, value, callback) {
				if (value == '' || value === undefined || value === null) {
					callback(new Error('日期不能为空'))
				} else {
					callback()
				}
			}
		},
	}
</script>